import React from 'react'

export default props => {

   const {
      steps,
      current,
      componentBack,
      componentFinish,
      componentNext,
      componentProgress
   } = props
   
   var position = steps.indexOf(current) + 1
   var lenght = steps.length
   var progress = 100 / lenght * position
   
   
   return (
      <div>
            { position > 1 && componentBack(steps[position-2])}
            {componentProgress(progress, position)}
            { position < lenght && componentNext(steps[position])}
            { position >= lenght && componentFinish}
         </div>
      )
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/StepsProgress/index.js